{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "virtual": {
    "itemHeight": 52,
    "display": 0
  },
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdatum",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "Belegdatum",
              "name": "belegdatum",
              "class": "",
              "titleClass": "hidden",
              "filter": true,
              "sortable": true
            },
            {
              "type": "text",
              "title": "",
              "text": "Neu",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "neuerBeleg",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            }
          ]
        }
      ]
    },
    {
      "type": "entity",
      "title": "Kunde",
      "name": "konto",
      "endpoint": "",
      "format": "{{number}} {{name}}",
      "class": "font-bold",
      "visible": {
        "name": "permission",
        "permission": "GESAMTABFRAGE.KUNDENSUCHE"
      }
    },
    {
      "type": "string",
      "title": "RechnungsNr.",
      "name": "bezugsnummer",
      "filter": true,
      "sortable": true
    },
    {
      "type": "date",
      "title": "Fälligkeit",
      "name": "faelligkeitsdatum",
      "filter": true,
      "sortable": true
    },
    {
      "type": "string",
      "title": "Objekt (Projektnummer in TR/SR)",
      "name": "objekt",
      "format": "{{objekt}}",
      "class": ""
    },
    {
      "type": "string",
      "title": "Belegart",
      "name": "belegart.kundenName",
      "filter": true,
      "sortable": true
    },
    {
      "type": "currency",
      "title": "Anzuweisender Betrag",
      "name": "zuwachs",
      "codeName": "currency",
      "titleClass": "!text-right",
      "filter": true,
      "sortable": true,
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "zuwachs",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "titleClass": "!text-right",
      "filter": true,
      "sortable": true,
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "gesamtIncl",
      "codeName": "currency",
      "titleClass": "!text-right",
      "filter": true,
      "sortable": true,
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamtIncl",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    },
    {
      "type": "action",
      "title": "Herunterladen",
      "control": "button",
      "variant": "outline",
      "action": "onDownload",
      "class": "c row center",
      "titleClass": "!text-center",
      "visible": {
        "name": "property",
        "property": "id",
        "rule": {
          "name": "required"
        }
      },
      "definition": {
        "type": "icon",
        "icon": "fas fa-cloud-download-alt"
      }
    }
  ]
}
